const FETCH_VERSIONS = "versions::load";
const FETCH_VERSIONS_FAILURE = "versions::load:failure";
const FETCH_VERSIONS_SUCCESS = "versions::load:success";
const VERSIONS_UNLOAD = "versions::unload";

const versionsUnloadAction = {
  type: VERSIONS_UNLOAD,
};

export {
  FETCH_VERSIONS,
  FETCH_VERSIONS_FAILURE,
  FETCH_VERSIONS_SUCCESS,
  VERSIONS_UNLOAD,
  versionsUnloadAction,
};
